// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"71198e67","496":"f16f5964","674":"347b7832","675":"bde1c9a2","696":"8967ee9a","770":"df405841","869":"7c8219d6","913":"e14d2714","947":"5e736339"}[chunkId] + ".chunk.js";
};